import React from 'react'

const RoyaleUserShare = ({ avatar, name = 'User', percent }) => {
  const formattedPercent = Number.isFinite(percent) ? `${percent.toFixed(2)}%` : '—'
  const fallbackName = encodeURIComponent(String(name || 'User'))
  const avatarUrl = avatar || `https://ui-avatars.com/api/?name=${fallbackName}&background=00FF7F&color=0A0A0F`

  return (
    <div className="flex items-center justify-center gap-3 rounded-2xl border border-white/10 bg-surface/60 px-4 py-3 lg:justify-between lg:px-5 lg:py-4">
      <img
        src={avatarUrl}
        alt={name}
        className="w-10 h-10 rounded-full object-cover border border-white/10 lg:w-12 lg:h-12"
      />
      <div className="min-w-0 flex-1 lg:text-right">
        <span className="text-white font-semibold text-lg tabular-nums lg:text-2xl">
          {formattedPercent}
        </span>
      </div>
    </div>
  )
}

export default RoyaleUserShare
